<div class="ui-percentage"><div class="ui-percentage__item" :style="'width:'+percent+'%'"></div></div>